import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=27e47c42&scoped=true&"
import script from "./HelpModal.vue?vue&type=script&lang=js&"
export * from "./HelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e47c42",
  null
  
)

export default component.exports